var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkin"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"text-big"},[_vm._v("Chấm công")]),_vm._v(" "),_c('p',{staticClass:"hour"},[_vm._v("\n                "+_vm._s(_vm.timenow)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('br'),_vm._v(" "),_c('qrcode-vue',{attrs:{"value":_vm.qr,"size":200,"className":'qr'}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-884a3dcc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckIn.vue
// module id = null
// module chunks = 